import type { ComponentProps } from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { cn } from '@shared/lib';

/**
 * Tooltip built on Radix (info hints). Wrap your app (or story/test) once in a
 * `TooltipProvider`. **A11y:** opens on hover *and* keyboard focus, `role="tooltip"`,
 * `Esc` dismisses. Don't put essential-only info here.
 */
export const TooltipProvider = TooltipPrimitive.Provider;
export const Tooltip = TooltipPrimitive.Root;
export const TooltipTrigger = TooltipPrimitive.Trigger;

export function TooltipContent({
  className,
  sideOffset = 6,
  children,
  ...props
}: ComponentProps<typeof TooltipPrimitive.Content>) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        data-slot="tooltip-content"
        sideOffset={sideOffset}
        className={cn(
          'z-50 max-w-xs rounded-md bg-fg-strong px-2 py-1 text-xs text-bg shadow-overlay',
          className,
        )}
        {...props}
      >
        {children}
        <TooltipPrimitive.Arrow className="fill-fg-strong" />
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  );
}
